/* eslint-disable*/
import "react-big-calendar/lib/sass/styles.scss";
import "react-datepicker/dist/react-datepicker.css";
import React, { useState, useEffect } from "react";
import { FormGroup, Label, ModalBody, Modal, ModalHeader } from "reactstrap";
import { BlurSpinner } from "../BlurSpinner";
import { useFormik } from "formik";
import { CheckSquare, Square } from "react-feather";
import { fetchNovedadPiAsignable } from "../../services/novedadesServices";
import useFetcher from "../../hooks/useFetcher";
import { StyledSelect } from "../StyledSelect";
import { handleErrors } from "../../services/handleErrors";
import SpinnerButton from "../Button";
import { fetchAlertaCategories, createAlerta, editarAlerta } from "../../services/alertasServices";
import ConfirmModal from "./ConfirmModal";
import { toast } from "react-toastify";
import RadioButton from "../RadioButton";
import DatePicker from "react-datepicker";
import moment from "moment";
import { validateDateForTask } from "./validateDateForTask";
import { queryDateFormatToDate } from "../../utils/datesUtils";
import ValidateModalMessage from "./ValidateModalMessage";

const ModalCrearEditarAlerta = ({ alertaInfo, toggle, subclientId, readonly }) => {
  const [confirmarModal, setConfirmarModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [frecuency, setFrecuency] = useState(null);
  const [closeWindows, setCloseWindows] = useState(true);
  const [modalValidationToggle, setModalValidationToggle] = useState(false);
  const [isAfter, setIsAfter] = useState(false);
  const [changes, setChanges] = useState({
    tipo: false,
    observations: false,
    concepto: false,
    entrega: false,
    dueDate: false,
    replicaMensual: false,
    notificarme: false,
    liderId: false,
    responsableId: false,
    observadorId: false,
  });
  const [selectedDate, setSelectedDate] = useState();
  const thisYear = moment().format("YYYY");
  const thisMonth = moment().format("MM");
  const firstDayToShow = moment().format("DD");
  const firstDateToShow = moment(`${thisMonth}/${firstDayToShow}/${thisYear}`).add(1, "day").format("MM/DD/YYYY");

  const formik = useFormik({
    validateOnMount: true,
    enableReinitialize: true,
    initialValues: {
      tipo: (alertaInfo.tipo && alertaInfo.tipo.id) || "",
      observations: alertaInfo.observations || "",
      concepto: (alertaInfo.concepto && alertaInfo.concepto.id) || "",
      entrega: alertaInfo.entrega || "",
      dueDate: alertaInfo.dueDate || "",
      replicaMensual: alertaInfo.replicaMensual || false,
      notificarme: alertaInfo.notificarme || false,
      liderId: alertaInfo.liderId || "",
      responsableId: alertaInfo.responsableId || "",
      observadorId: alertaInfo.observadorId,
      id: alertaInfo.id || null,
    },

    onSubmit: async (alertaInfo) => {
      try {
        setIsLoading(true);
        const alertaBody = {
          tipo: alertaInfo.tipo.id ? alertaInfo.tipo.id : alertaInfo.tipo ? alertaInfo.tipo : "",
          observations: alertaInfo.observations || "",
          concepto: alertaInfo.concepto.id ? alertaInfo.concepto.id : alertaInfo.concepto ? alertaInfo.concepto : "",
          replicaMensual: alertaInfo.replicaMensual || false,
          notificarme: alertaInfo.notificarme || false,
          liderId: alertaInfo.liderId || null,
          responsableId: alertaInfo.responsableId || null,
          observadorId: alertaInfo.observadorId || null,
          id: alertaInfo.id || null,
        };
        if (alertaBody.id !== null) {
          setIsAfter(false);
        } else {
          if (frecuency && frecuency == 2) {
            const fecha = moment().date(alertaInfo.entrega).format("YYYY-MM-DD");
            setIsAfter(validateDateForTask(fecha));
            alertaBody.replicaMensual = true;
            alertaBody.entrega = alertaInfo.entrega;
            alertaBody.dueDate = null;
          }
          if (frecuency && frecuency == 1) {
            alertaBody.replicaMensual = false;
            alertaBody.dueDate = alertaInfo.dueDate;
            alertaBody.entrega = null;
            setIsAfter(validateDateForTask(alertaInfo.dueDate));
          }
        }
        const res = alertaBody.id !== null && subclientId !== undefined ? await editarAlerta(subclientId, alertaBody) : await createAlerta(subclientId, alertaBody);
        setConfirmarModal(false);

        setChanges({
          tipo: false,
          observations: false,
          concepto: false,
          entrega: false,
          dueDate: false,
          replicaMensual: false,
          notificarme: false,
          liderId: false,
          responsableId: false,
          observadorId: false,
        });

        alertaBody.id !== undefined ? toast.success("Alerta Actualizada") : toast.success("Alerta Creada");
        // toggle();
        setModalValidationToggle(true);

        // setCloseWindows(false);
        setIsLoading(false);
      } catch (error) {
        handleErrors(error);
      }
    },
    validate: (values) => {
      let errors = {};
      if (!values.tipo || values.tipo == "") {
        errors.tipo = "Campo Obligatorio";
      }
      if (!values.concepto || values.concepto == "") {
        errors.concepto = "Campo Obligatorio";
      }
      if (!values.liderId || values.liderId == "") {
        errors.liderId = "Campo Obligatorio";
      }
      if (!values.responsableId || values.responsableId == "") {
        errors.responsableId = "Campo Obligatorio";
      }
      if (frecuency === 2) {
        if (!values.entrega || values.entrega == "") {
          errors.entrega = "Campo Obligatorio";
        }
        if (values.entrega < 1) {
          errors.entrega = "Valor Min: 1";
        }
        if (values.entrega > 30) {
          errors.entrega = "Valor Max: 30";
        }
      }
      if (frecuency === 1) {
        if (!values.dueDate || values.dueDate == "") {
          errors.dueDate = "Campo Obligatorio";
        }
      }

      return errors;
    },
    // validationSchema: Yup.object().shape({
    //   tipo: Yup.number().required("Campo Obligatorio"),
    //   observations: Yup.string().nullable(),
    //   responsableId: Yup.number().required(),
    //   liderId: Yup.number().required(),
    //   concepto: Yup.number().required(),
    //   entrega: Yup.number().min(0, "Min value 0.").max(30, "Max value 30."),

    //   replicaMensual: Yup.boolean().nullable(),
    //   notificarme: Yup.boolean().nullable(),
    //   observadorId: Yup.number().nullable(),
    // }),
  });
  const [pisAsignable, isLoadingAsignable] = useFetcher(fetchNovedadPiAsignable);
  const [opcionAsignable, setAsignable] = useState();
  const [notificarmeState, setNotificarmeState] = useState(formik.values.notificarme);
  const tipoOptions = opcionAsignable
    ? opcionAsignable.tarea.type.map((assigned) => {
        return { label: assigned.text, value: assigned.id };
      })
    : [];

  const conceptoOptions = opcionAsignable
    ? opcionAsignable.concepto.type.map((assigned) => {
        return { label: assigned.text, value: assigned.id };
      })
    : [];

  const conceptoOptionsFiltered = conceptoOptions && formik.values.tipo !== 1 ? conceptoOptions.filter((item) => item.value == 5) : conceptoOptions;

  const piOptions = pisAsignable
    ? pisAsignable.map((assigned) => {
        return { label: assigned.nombreApellido, value: assigned.itemId };
      })
    : [];
  const piOptionsResponsable = pisAsignable
    ? pisAsignable
        .filter((assigned) => assigned.itemId !== formik.values.liderId)
        .map((assigned) => {
          return { label: assigned.nombreApellido, value: assigned.itemId };
        })
    : [];
  const piOptionsLider = pisAsignable
    ? pisAsignable
        .filter((assigned) => assigned.itemId !== formik.values.responsableId)
        .map((assigned) => {
          return { label: assigned.nombreApellido, value: assigned.itemId };
        })
    : [];
  const responsableValue = piOptions.find((option) => {
    return option.value === formik.values.responsableId;
  });

  const liderValue = piOptions.find((option) => {
    return option.value === formik.values.liderId;
  });
  const observadorValue = piOptions.find((option) => {
    return option.value === formik.values.observadorId;
  });

  const handleBlur = (value) => {
    if (alertaInfo) {
      if (formik.values[value] !== alertaInfo[value]) {
        setChanges((prevState) => ({ ...prevState, [value]: true }));
      } else {
        setChanges((prevState) => ({ ...prevState, [value]: false }));
        return;
      }
    }
    if (formik.values[value] != null) {
      setChanges((prevState) => ({ ...prevState, [value]: true }));
    } else {
      setChanges((prevState) => ({ ...prevState, [value]: false }));
    }
  };

  const handleMonthChange = (selected) => {
    setSelectedDate(selected);
    const formattedDate = moment(selected).format("yyyy/MM/DD");
    formik.setFieldValue("dueDate", formattedDate);
  };

  useEffect(async () => {
    try {
      setIsLoading(true);
      const categories = await fetchAlertaCategories();
      setAsignable(categories);
    } catch (error) {
      handleErrors(error);
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (alertaInfo) {
      if (alertaInfo.dueDate) {
        setFrecuency(1);
        setSelectedDate(queryDateFormatToDate(alertaInfo.dueDate));
      }
      if (alertaInfo.entrega) {
        setFrecuency(2);
      }
    }
  }, [alertaInfo]);

  return (
    <Modal centered isOpen={closeWindows} toggle={toggle}>
      {confirmarModal && (
        <ConfirmModal
          toggle={() => {
            setConfirmarModal(!confirmarModal);
          }}
          handleSubmitArea={formik.handleSubmit}
          dataAlert={{ selectedDate, frecuency, formik }}
        />
      )}
      {modalValidationToggle && (
        <ValidateModalMessage
          toggle={() => {
            setModalValidationToggle(!modalValidationToggle);
          }}
          isAfter={isAfter}
          handleOkClick={() => {
            setModalValidationToggle(!modalValidationToggle);
            setCloseWindows(!closeWindows);
            toggle();
          }}
        />
      )}
      <ModalHeader toggle={toggle}></ModalHeader>
      <ModalBody>
        <BlurSpinner isLoading={isLoading}>
          {alertaInfo && (
            <FormGroup className=" w-100">
              <FormGroup className="d-flex justify-content-between">
                <Label htmlFor="responsable" className="col-form-label p-0 w-100">
                  Responsable
                  <StyledSelect
                    id="responsableId"
                    name="responsableId"
                    className="col-form-label p-0 w-100"
                    formik={formik}
                    required
                    value={responsableValue}
                    placeholder="Seleccione Responsable"
                    isClearable
                    isLoading={isLoadingAsignable}
                    disabled={formik.isSubmitting || isLoadingAsignable}
                    options={piOptionsResponsable}
                    onBlur={() => handleBlur("responsableId")}
                    isDisabled={formik.values.id && readonly ? true : false}
                  />
                  <div className="input-feedback d-flex  justify-content-end">
                    {formik.errors.responsableId && (
                      <div style={{ height: "10px", padding: "0px" }} className="input-feedback m-1 d-flex flex-column align-items-end">
                        {formik.errors.responsableId}
                      </div>
                    )}
                    {changes.responsableId ? (
                      <div style={{ height: "10px", padding: "0px" }} className="input-feedback m-1 d-flex flex-column align-items-end">
                        Cambios por guardar
                      </div>
                    ) : (
                      <div style={{ height: "10px", padding: "0px" }} />
                    )}
                  </div>
                </Label>
              </FormGroup>
              <FormGroup className="d-flex justify-content-between">
                <Label htmlFor="lider" className="col-form-label p-0 w-100">
                  Líder
                  <StyledSelect
                    id="liderId"
                    name="liderId"
                    className="col-form-label p-0 w-100"
                    formik={formik}
                    required
                    value={liderValue}
                    placeholder="Seleccione lider"
                    isClearable
                    isLoading={isLoadingAsignable}
                    disabled={formik.isSubmitting || isLoadingAsignable}
                    options={piOptionsLider}
                    onBlur={() => handleBlur("liderId")}
                    isDisabled={formik.values.id && readonly ? true : false}
                  />
                  <div className="input-feedback d-flex  justify-content-end">
                    {formik.errors.liderId && (
                      <div style={{ height: "10px", padding: "0px" }} className="input-feedback m-1 d-flex flex-column align-items-end">
                        {formik.errors.liderId}
                      </div>
                    )}
                    {changes.liderId ? (
                      <div style={{ height: "10px", padding: "0px" }} className="input-feedback m-1 d-flex flex-column align-items-end">
                        Cambios por guardar
                      </div>
                    ) : (
                      <div style={{ height: "10px", padding: "0px" }} />
                    )}
                  </div>
                </Label>
              </FormGroup>
              <FormGroup>
                <Label htmlFor="tipo" className="col-form-label pt-0 w-100">
                  Tipo
                  <StyledSelect
                    id="tipo"
                    name="tipo"
                    className="w-100"
                    formik={formik}
                    required
                    value={
                      tipoOptions.find((option) => {
                        return option.value === formik.values.tipo;
                      }) || ""
                    }
                    placeholder="Seleccione Tipo"
                    isClearable
                    disabled={formik.isSubmitting || isLoadingAsignable || isLoading}
                    isLoading={isLoading}
                    options={tipoOptions}
                    onBlur={() => handleBlur("tipo")}
                    onChange={(v) => {
                      if (v.value == 2 || v.value == 3 || v.value == 4) {
                        formik.setFieldValue("concepto", null);
                      }
                    }}
                    isDisabled={formik.values.id && readonly ? true : false}
                  />
                  <div className="input-feedback d-flex  justify-content-end">
                    {formik.errors.tipo && (
                      <div style={{ height: "10px", padding: "0px" }} className="input-feedback m-1 d-flex flex-column align-items-end">
                        {formik.errors.tipo}
                      </div>
                    )}
                    {changes.tipo ? (
                      <div style={{ height: "10px", padding: "0px" }} className="input-feedback m-1 d-flex flex-column align-items-end">
                        Cambios por guardar
                      </div>
                    ) : (
                      <div style={{ height: "10px", padding: "0px" }} />
                    )}
                  </div>
                </Label>

                <Label htmlFor="concepto" className="col-form-label pt-0 w-100">
                  Concepto
                  <StyledSelect
                    id="concepto"
                    name="concepto"
                    className="w-100"
                    formik={formik}
                    required
                    value={
                      conceptoOptionsFiltered.find((option) => {
                        return option.value === formik.values.concepto;
                      }) || ""
                    }
                    placeholder="Seleccione concepto"
                    isClearable
                    disabled={isLoadingAsignable || isLoading}
                    isLoading={isLoading}
                    options={conceptoOptionsFiltered}
                    onBlur={() => handleBlur("concepto")}
                    isDisabled={formik.values.id && readonly ? true : false}
                  />
                  <div className="input-feedback d-flex  justify-content-end">
                    {formik.errors.concepto && (
                      <div style={{ height: "10px", padding: "0px" }} className="input-feedback m-1 d-flex flex-column align-items-end">
                        {formik.errors.concepto}
                      </div>
                    )}
                    {changes.concepto ? (
                      <div style={{ height: "10px", padding: "0px" }} className="input-feedback m-1 d-flex flex-column align-items-end">
                        Cambios por guardar
                      </div>
                    ) : (
                      <div style={{ height: "10px", padding: "0px" }} />
                    )}
                  </div>
                </Label>

                <FormGroup className="d-flex justify-content-between">
                  <Label htmlFor="observador" className="col-form-label p-0 w-100">
                    Observador
                    <StyledSelect
                      id="observadorId"
                      name="observadorId"
                      className="col-form-label p-0 w-100"
                      formik={formik}
                      required
                      value={observadorValue}
                      placeholder="Seleccione Observador"
                      isClearable
                      isLoading={isLoadingAsignable}
                      disabled={formik.isSubmitting || isLoadingAsignable}
                      options={piOptions}
                      onBlur={() => handleBlur("observadorId")}
                      isDisabled={formik.values.id && readonly ? true : false}
                    />
                    {changes.observadorId ? (
                      <div style={{ height: "10px", padding: "0px" }} className="input-feedback d-flex flex-column align-items-end">
                        Cambios por guardar
                      </div>
                    ) : (
                      <div style={{ height: "10px", padding: "0px" }} />
                    )}
                  </Label>
                </FormGroup>
                <FormGroup className="col-form-group p-0 mb-2 w-100" style={{ margin: 0 }}>
                  <Label htmlFor="frecuencia" className="col-form-label p-0 w-100">
                    Frecuencia
                  </Label>
                  <RadioButton className="radio-button" setter={setFrecuency} value={frecuency} disabled={formik.values.id && readonly ? true : false} />
                  {frecuency && frecuency == 1 && (
                    <div>
                      <DatePicker
                        name="dueDate"
                        className="form-control"
                        dateFormat="dd / MM / yy"
                        selected={selectedDate}
                        onChange={handleMonthChange}
                        minDate={new Date(firstDateToShow)}
                        maxDate={new Date(`12/31/${thisYear + 2}`)}
                        disabled={formik.values.id && readonly ? true : false}
                      />
                      <div style={{ height: "15px", padding: "0px" }} className="input-feedback d-flex  justify-content-end">
                        {formik.errors.dueDate && (
                          <div style={{ height: "15px", padding: "0px" }} className="input-feedback m-1 d-flex flex-column align-items-end">
                            {formik.errors.dueDate}
                          </div>
                        )}
                        {changes.dueDate ? (
                          <div style={{ height: "15px", padding: "0px" }} className="input-feedback m-1 d-flex flex-column align-items-end">
                            Cambios por guardar
                          </div>
                        ) : (
                          <div style={{ height: "15px", padding: "0px" }} />
                        )}
                      </div>
                    </div>
                  )}
                  {frecuency && frecuency == 2 && (
                    <div>
                      <input
                        className={formik.errors.entrega && formik.touched.entrega ? "form-control error-field w-100" : "form-control w-100"}
                        type="number"
                        name="entrega"
                        onChange={formik.handleChange}
                        onBlur={() => handleBlur("entrega")}
                        value={formik.values.entrega}
                        min={1}
                        max={30}
                        disabled={(formik.values.id && readonly) || !frecuency}
                        onWheel={() => this.blur()}
                      />
                      <div style={{ height: "15px", padding: "0px" }} className="input-feedback d-flex  justify-content-end">
                        {formik.errors.entrega && (
                          <div style={{ height: "15px", padding: "0px" }} className="input-feedback m-1 d-flex flex-column align-items-end">
                            {formik.errors.entrega}
                          </div>
                        )}
                        {changes.entrega ? (
                          <div style={{ height: "15px", padding: "0px" }} className="input-feedback m-1 d-flex flex-column align-items-end">
                            Cambios por guardar
                          </div>
                        ) : (
                          <div style={{ height: "15px", padding: "0px" }} />
                        )}
                      </div>
                    </div>
                  )}
                </FormGroup>
                <FormGroup className="form-group" style={{ margin: 0 }}>
                  <Label htmlFor="observaciones" className="col-form-label  pt-0 w-100">
                    Observaciones
                    <textarea
                      name="observations"
                      onBlur={() => handleBlur("observations")}
                      rows={2}
                      className="w-100"
                      value={formik.values.observations}
                      onChange={formik.handleChange}
                      disabled={formik.values.id && readonly ? true : false}
                    ></textarea>
                    {changes.observations ? (
                      <div style={{ height: "15px", padding: "0px" }} className="input-feedback d-flex flex-column align-items-end">
                        Cambios por guardar
                      </div>
                    ) : (
                      <div style={{ height: "15px", padding: "0px" }} />
                    )}
                  </Label>
                </FormGroup>
                <FormGroup className="d-flex align-items-center justify-content-around">
                  <FormGroup
                    className="d-flex align-items-center"
                    onClick={() => {
                      if (!(formik.values.id && readonly)) {
                        formik.values.notificarme = !formik.values.notificarme;
                        setNotificarmeState(formik.values.notificarme);
                        formik.handleBlur("notificarme");
                      }
                    }}
                  >
                    <Label className="mr-2">Notificarme</Label>

                    <div name="replicaMensual">
                      {notificarmeState ? (
                        <span className="action-box complete-btn" title="Completado">
                          <CheckSquare color="red" />
                        </span>
                      ) : (
                        <span className="action-box complete-btn" title="Incompleto">
                          <Square />
                        </span>
                      )}
                    </div>
                  </FormGroup>
                </FormGroup>
              </FormGroup>
              <FormGroup className="mt-3 px-3 w-100 d-flex flex-column align-items-end ">
                {!(formik.values.id && readonly) && (
                  <SpinnerButton className="btn btn-primary btn-block" isLoading={isLoading} disabled={false} onClick={() => setConfirmarModal(!confirmarModal)}>
                    Guardar Cambios
                  </SpinnerButton>
                )}
              </FormGroup>
            </FormGroup>
          )}
        </BlurSpinner>
      </ModalBody>
    </Modal>
  );
};
export default ModalCrearEditarAlerta;
